import { render, staticRenderFns } from "./ThreatManagementSettingsForm.vue?vue&type=template&id=5b33cc2f"
import script from "./ThreatManagementSettingsForm.vue?vue&type=script&lang=js"
export * from "./ThreatManagementSettingsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports